import { HTTP_GET } from '../const';
import { LOAD_BALANCES } from "@/store/const/node";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    [LOAD_BALANCES]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_BALANCES,
        namespace: 'node',
        no_commit: true,
      }, { root: true });
    },
  },
  mutations: {},
};
